enum OUConditionType {
  New = 100,
  Reconditioned = 80,
  OpenBox = 60,
  Used = 40,
  Broken = 20,
  Other = 0
}

export default OUConditionType
